var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('BoardView',{attrs:{"sub":_vm.project.name,"title":_vm._f("name")(_vm.user)}},[_c('section',[_c('CardReservation',{attrs:{"reservation":_vm.reservation}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }